export function areActionCodesSupported() {
  return false;
}
